import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  mainSubContainer: {
    justifyContent: 'flex-start',
    flex: 1,
    marginTop: 10,
  },
  textContainer: {
    marginLeft: 10,
    marginRight: 5,
    flex: 1,
  },
  pillContainer: {
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    marginBottom: 3.5,
    gap: 5,
  },
  textHeader: {
    textAlign: 'left',
    flex: 1,
  },
  priceText: {
    textAlign: 'left',
    marginVertical: 5,
  },
  locationTypo: {
    textDecorationLine: 'underline',
  },
  locationContainer: {
    paddingTop: 10,
  },
  editQyt: {
    textAlign: 'left',
    paddingRight: 5,
    fontFamily: font.fonts.muliSemiBold,
  },
  editQtyBox: {
    justifyContent: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
  },
  itemLocationContainer: {
    paddingLeft: 10,
    borderRadius: 30,
    flexDirection: 'row',
  },
  container: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    borderRadius: 25,
    overflow: 'hidden',
    height: 30,
    width: 'auto',
    marginBottom: 5,
  },
  gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 25,
  },
});

export const notesBoxStyles = StyleSheet.create({
  seeMore: {
    paddingRight: 20,
    textDecorationLine: 'underline',
  },
  seeLess: {
    paddingRight: 20,
    textDecorationLine: 'underline',
  },
  notesText: {
    textAlign: 'left',
  },
  notesBox: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    width: '90%',
  },
});

export const quantityPillStyles = StyleSheet.create({
  highlightText: {
    borderRadius: 20,
    paddingHorizontal: 10,
    paddingVertical: 2.5,
  },
  infoBox: {
    paddingHorizontal: 10,
    borderRadius: 20,
    paddingVertical: 3,
  },
  containerBox: {
    flexDirection: 'row',
  },
});
